import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Row,
  Col,
  Image,
  Radio,
  message,
} from "antd";

import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import Swal from "sweetalert2";
import moment from "moment";

import { useSelector, useDispatch } from "react-redux";
import UploadFile from "../../components/UploadFile";
import modulesApi from "../../api/module/modulesApi";
import pageApi from "../../api/pageApi";

import { fileManagerActions } from "../../store";
import { LocalImage } from "../../components/ImageUtil";

const dataExample = {
  page: null,
  title: null,
  textPosition: null,
  description: null,
  image: null,
  itemIndex: null,
};

const HomeIntroduction = (props) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  const [form] = Form.useForm();
  const { TextArea } = Input;

  const [pages, setPages] = useState([]);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [valueForm, setValueForm] = useState();
  const [isEditModal, setIsEditModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [items, setItems] = useState([]);

  const { fileImageUrl } = useSelector((x) => x.fileManager);

  useEffect(() => {
    form.setFieldsValue(valueForm);
  }, [form, valueForm, isEditModal]);

  useEffect(() => {
    getPages();
    getHomeIntroduction();
  }, []);

  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };

  const getHomeIntroduction = () => {
    setLoading(true);
    modulesApi
      .getHomeIntroduction()
      .then((res) => {
        if (res?.values !== null) {
          setLoading(false);
          const data = res?.values;
          setItems(data);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getPages = () => {
    const params = {
      page: 1,
      limit: 10000,
    };
    pageApi.getPages(params).then((res) => {
      if (res) {
        const data = res?.results.map((item) => {
          return { text: item.title, value: item.id };
        });
        setPages(data);
      }
    });
  };

  const columns = [
    {
      title: "STT",
      render: (id, record, index) => {
        ++index;
        return index;
      },
      className: "text-center",
      width: "5%",
    },

    {
      title: "Ảnh nền",
      dataIndex: "image",
      key: "image",
      render: (image) => (
        <>
          <LocalImage
            src={image}
            width={100}
            style={{ objectFit: "contain" }}
            height={100}
          />
        </>
      ),
      width: 250,
      className: "text-center",
    },
    {
      title: "Tiêu đề",
      dataIndex: "title",
      render: (text) => <h3>{text}</h3>,
      width: "15%",
    },
    {
      title: "Trang động",
      dataIndex: "page",
      render: (page) => <span>{page?.title}</span>,
      width: "15%",
    },
    {
      title: "Mô tả",
      dataIndex: "description",
      render: (text) => <h6>{text}</h6>,
    },
    {
      title: "Vị trí content",
      dataIndex: "textPosition",
      render: (active) => (
        <>
          {active === "top" && (
            <Tag color="#87d068" key={active}>
              Trên
            </Tag>
          )}
          {active === "bottom" && (
            <Tag color="#108ee9" key={active}>
              Dưới
            </Tag>
          )}
        </>
      ),
      width: "10%",
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record, index) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record, index)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteSection(index)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
    },
  ];

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const closePopup = useCallback(() => {
    setValueForm({});
    form.resetFields();
    setIsModalEditVisible(false);
  }, [form]);

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        updateSection({ ...values, image: fileImageUrl });
      } else {
        if (fileImageUrl !== null) {
          createSection({ ...values, image: fileImageUrl });
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Vui lòng tải ảnh lên!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
      }
    },
    [isEditModal, fileImageUrl]
  );
  const confirm = Modal.confirm;

  const deleteSection = (index) => {
    confirm({
      title: "Bạn có muốn xóa mục này không?",
      onOk() {
        const _items = items;
        _items.splice(index, 1);

        const mapData = _items.map((item) => {
          return {
            page: item.page.id,
            image: item.image,
            title: item.title,
            textPosition: item.textPosition,
            description: item.description,
            image: item.image,
          };
        });

        const payload = {
          "home-introduction": mapData,
        };
        actionApi(payload);
      },
      onCancel() {},
    });
  };

  const updateSection = (values) => {
    setLoading(true);
    const item = {
      page: values.page,
      title: values.title,
      textPosition: values.textPosition,
      description: values.description,
      image: values.image,
    };

    const mapData = items.map((item) => {
      return {
        page: item.page.id,
        title: item.title,
        textPosition: item.textPosition,
        description: item.description,
        image: item.image,
      };
    });

    const newState = mapData.map((obj, index) => {
      if (index === values.itemIndex) {
        return { ...obj, ...item };
      }
      return obj;
    });

    const payload = {
      "home-introduction": newState,
    };

    actionApi(payload);
  };

  const createSection = (values) => {
    const item = {
      page: values.page,
      title: values.title,
      textPosition: values.textPosition,
      description: values.description,
      image: values.image,
    };

    const mapData = items.map((item) => {
      return {
        page: item.page.id,
        title: item.title,
        textPosition: item.textPosition,
        description: item.description,
        image: item.image,
      };
    });

    const payload = {
      "home-introduction": [...mapData, item],
    };

    actionApi(payload);
  };

  const actionApi = (payload) => {
    setLoading(true);
    modulesApi
      .createModules(payload)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Thao tác thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          getHomeIntroduction();
          setIsModalEditVisible(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const showCreateModal = () => {
    setTitleModal("Thêm mục");
    setIsEditModal(false);
    setValueForm(dataExample);
    setImageNull(null);
    setIsModalEditVisible(true);
  };

  const showEditModal = (record, index) => {
    setIsEditModal(true);
    setTitleModal("Sửa mục");
    setImageNull(record.image);
    setValueForm({
      page: record.page.id,
      title: record.title,
      textPosition: record.textPosition,
      description: record.description,
      itemIndex: index,
    });
    setIsModalEditVisible(true);
  };

  return (
    <>
      <div className="tabled">
        <Space size={10}>
          <Button type="dashed" size="small" onClick={() => showCreateModal()}   disabled={items.length >= 4}>
            <EditOutlined /> &nbsp; Thêm mục giới thiệu
          </Button>
        </Space>
        <br />
        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
          <div className="table-responsive">
            <Table
              rowKey={(record) => Math.random() * 100}
              loading={loading}
              columns={columns}
              dataSource={items}
              bordered
              className="ant-border-space"
              pagination={{
                position: ['none'],
              }}
            />
          </div>
        </Card>
      </div>

      <Modal
        title={titleModal}
        visible={isModalEditVisible}
        onOk={form.submit}
        width={800}
        onCancel={() => {
          closePopup();
        }}
      >
        <div>
          <Form
            initialValues={valueForm}
            form={form}
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item hidden={true} label="itemIndex" name="itemIndex">
              <Input />
            </Form.Item>

            <Row gutter={[24, 0]}>
              <Col span={12}>
                <Form.Item
                  label="Trang động"
                  name="page"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn!",
                    },
                  ]}
                >
                  <Select
                    showArrow
                    showSearch
                    size="large"
                    placeholder="Chọn trang động..."
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {pages == null || pages === "undefined" || pages === []
                      ? []
                      : pages.map((item, key) => (
                          <Option key={key} value={item.value}>
                            {item.text}
                          </Option>
                        ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Tiêu đề"
                  name="title"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập tiêu đề!",
                    },
                  ]}
                >
                  <Input placeholder="Nhập tiêu đề..." />
                </Form.Item>
                <Form.Item
                  label="Mô tả"
                  name="description"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập !",
                    },
                  ]}
                >
                  <TextArea rows={5} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  tooltip="Chon vị trí content hiển thị trên hay dưới ảnh "
                  label="Vi trí content"
                  name="textPosition"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn!",
                    },
                  ]}
                >
                  <Radio.Group>
                    <Radio value="top">Trên</Radio>
                    <Radio value="bottom">Dưới</Radio>
                  </Radio.Group>
                </Form.Item>

                <Row>
                  <Col>
                    <Form.Item label="Ảnh nền">
                      <UploadFile />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default HomeIntroduction;
